export enum ResidencyType {
  PresentAddress = "PresentAddress",
  FormerAddress = "FormerAddress",
  MailingAddress = "MailingAddress",
}
